<template>
    <div id="prompt" v-show="prompt">
        <div class="mask" @click="closedMask" ref="masker"></div>
        <img src="http://shared.youdao.com/dict/market/oxford-activity/imgs/save.png" v-show="save" alt="">
        <img src="http://shared.youdao.com/dict/market/oxford-activity/imgs/share.png" v-show="share" alt="">
        <!-- <img src="../assets/getOneMounth.png" alt="" v-show="getSuccess"> -->
    </div>
</template>

<script>
    export default {
        name: 'GetCode',
        props: {
            prompt: '',
            share: '',
            save: '',
            getSuccess: ''
        },
        methods: {
            closedMask: function () {
                this.$emit('closed')
            }
        }
    }
</script>

<style>
    #prompt {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #000;
        opacity: 0.5;
        filter: alpha(opacity=50);
    }
    #prompt img {
        position: fixed;
        width: 5.32rem;
        top: 4.5rem;
        left: 50%;
        bottom: 0;
        right: 0;
        z-index: 99;
        margin-left: -2.66rem;
        background-image: url(http://shared.youdao.com/dict/market/oxford-activity/imgs/login.png);
        background-size: 100% 100%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// Prompt.vue?51c787b7